// Hairline edge for subtle filled surfaces, so sibling cards and inputs never land on different border weights.
export const subtleSurfaceRing = "ring-1 ring-black/[0.07] dark:ring-white/10"

// Clicking into a text surface steps its hairline up. focus-within, because the
// ring sits on the label that wraps the input, not on the input itself.
export const subtleSurfaceFocusRing =
	"focus-within:ring-black/[0.12] dark:focus-within:ring-white/[0.14]"

// Soft lift that pairs with subtleSurfaceRing on elevated variants of those surfaces.
export const subtleSurfaceShadow =
	"shadow-sm shadow-gray-500/10 dark:shadow-black"
